import { PropsWithChildren } from 'react';
import { layoutLandscapeMiniGridStyle } from './layout-landscape-mini.styles.css';

export type LayoutLandscapeMiniProps = {
    type?: 'featured' | 'premium';
};

const LayoutLandscapeMini: React.FC<
    PropsWithChildren<LayoutLandscapeMiniProps>
> = ({ type, children }) => {
    return (
        <div className={layoutLandscapeMiniGridStyle({ type })}>{children}</div>
    );
};

export { LayoutLandscapeMini };
